<header class="header">
  <img src="icons/logo-afpcapital.svg" alt="Logo SURA" />
</header>
